<template>
	<div class="support-list">
		<div class="list-con">
			<div class="title">
				<i class="x-icon-support"></i><span class="x-tit-con">Key Cutting Machine</span>
			</div>
			<ul class="list">
				<li>
					<router-link class="news-link" to="" @click.native="goWhere(1,$event)">
						<div class="news-skin x-flow">
							<img :src="newImage_01" alt="Xhorse"/>
						</div>
						<div class="news-title x-flow">
							<h3 class="all-w title">Xhorse uses AI to empower key machines</h3>
							<span class="all-w time x-inline">2020-08-12</span>
							<p class="all-w">
								Xhorse is always committed to providing professional, flexible, fast, and stable security solutions and automotive tools for all the locksmiths worldwide. </p>
						</div>
					</router-link>
				</li>
				<li>
					<router-link class="news-link" to="">
						<div class="news-skin x-flow">
							<img :src="newImage_02" alt="Xhorse"/>
						</div>
						<div class="news-title x-flow">
							<h3 class="all-w title">Xhorse focuses on the automotive safety industry</h3>
							<span class="all-w time x-inline">2020-08-11</span>
							<p class="all-w">
								With three Key Cutting Machine Series, CONDOR, DOLPHIN, and PANDA, Xhorse offers an all-sided professional solution for your security business</p>
						</div>
					</router-link>
				</li>
				<li>
					<router-link class="news-link" to="">
						<div class="news-skin x-flow">
							<img :src="newImage_03" alt="Xhorse"/>
						</div>
						<div class="news-title x-flow">
							<h3 class="all-w title">Xhorse holds a new product launch conference</h3>
							<span class="all-w time x-inline">2020-08-09</span>
							<p class="all-w">xhorse will hold a new product launch conference on August 15.</p>
						</div>
					</router-link>
				</li>
				<li>
					<router-link class="news-link" to="">
						<div class="news-skin x-flow">
							<img :src="newImage_04" alt="Xhorse"/>
						</div>
						<div class="news-title x-flow">
							<h3 class="all-w title">Xhorse uses AI to empower key machines</h3>
							<span class="all-w time x-inline">2020-08-12</span>
							<p class="all-w">
								Xhorse is always committed to providing professional, flexible, fast, and stable security solutions and automotive tools for all the locksmiths worldwide. </p>
						</div>
					</router-link>
				</li>
				<li>
					<router-link class="news-link" to="">
						<div class="news-skin x-flow">
							<img :src="newImage_05" alt="Xhorse"/>
						</div>
						<div class="news-title x-flow">
							<h3 class="all-w title">Xhorse focuses on the automotive safety industry</h3>
							<span class="all-w time x-inline">2020-08-11</span>
							<p class="all-w">
								With three Key Cutting Machine Series, CONDOR, DOLPHIN, and PANDA, Xhorse offers an all-sided professional solution for your security business</p>
						</div>
					</router-link>
				</li>

			</ul>
		</div>
	</div>
</template>

<script>
    import newImage_01 from '@/assets/resource/images/support/image_support_article_cover_01.png'
    import newImage_02 from '@/assets/resource/images/support/image_support_article_cover_01.png'
    import newImage_03 from '@/assets/resource/images/support/image_support_article_cover_01.png'
    import newImage_04 from '@/assets/resource/images/support/image_support_article_cover_01.png'
    import newImage_05 from '@/assets/resource/images/support/image_support_article_cover_01.png'
    export default {
        props: ['activeSideIndex'],
        methods: {
            goWhere(supportId, event){
                const _this = this;
                _this.$emit('go', {type: 'side', val: ["3"]});
                $(".side,.body").removeClass('support-cutting-class').addClass('support-cutting-detail-class');
            }
        },
        data(){
            return {
                newImage_01: newImage_01,
                newImage_02: newImage_02,
                newImage_03: newImage_03,
                newImage_04: newImage_04,
                newImage_05: newImage_05,
                componentId: 3
            };
        }

    }

</script>

<style scoped>
	.list > li > .news-link > .news-title:hover .all-w {
		color: #F5A623;
	}

	.list > li > .news-link {
		display: block;
		width: 100%;
		height: 100%;
		border: none;
	}

	.news-title .title {
		margin-bottom: 7px;
	}

	.news-title .time {
		margin-bottom: 16px;
	}

	.news-title > p {
		font-family: "Open SB";
		ont-size: 16px;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 28px;
	}

	.news-title > .time {
		font-family: "Open SB";
		font-size: 16px;
		color: #515555;
		letter-spacing: 0;
	}

	.news-title > .title {
		font-family: "Open SB";
		font-size: 24px;
		color: #3B3A38;
		letter-spacing: 0;
	}

	.news-title > .all-w {
		width: 100%;
	}

	.news-skin {
		width: 240px;
		height: 160px;
		border: none;
	}

	.news-skin img {
		width: 100%;
		height: 100%;
		margin-top: 32.5px;
	}

	.news-title {
		width: calc(100% - 32px - 240px);
		height: 160px;
		margin-top: 32.5px;
		margin-left: 32px;
		text-align: left;
	}

	.list > li {
		width: 100%;
		height: 224px;
		border: none;
		border-bottom: 1px solid #D7D7D7
	}

	.list-con > .list {
		width: 70%;
		height: 1303px;
		margin-left: calc(5% + 54px);
	}

	.list-con > .title {
		width: 90%;
		margin: 0 auto;
		text-align: left;
		margin-top: 44px;
		margin-bottom: 44px;
		line-height: 44px;
	}

	.support-list > .list-con {
		width: 100%;
		height: 100%;
	}

	.x-icon-support {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_news.png");
		width: 44px;
		height: 44px;
		position: relative;
		top: 10px;
		margin-right: 10px;
	}

	.x-tit-con /deep/ {
		font-family: Open Sans;
		font-size: 24px;
		color: #3B3A38;
		line-height: 52px;
	}

</style>


// WEBPACK FOOTER //
// src/components/zh-cn/support/support-tech.vue